import { z } from 'zod';
import { IAsset } from './IAsset';
import { IAssetCategoryId } from './IAssetCategory';
import { AssetLocationSchema, IAssetLocation } from './IAssetLocation';
import { IAssetTypeId } from './IAssetType';
import { GenericAssetSchema } from './IGenericAsset';

export const BankAccountAssetVersion = {
  Initial: 1,
} as const;

export type BankAccountAssetVersion =
  (typeof BankAccountAssetVersion)[keyof typeof BankAccountAssetVersion];

export function getEmptyBankAccountAsset(idAsset: number): IBankAccountAsset {
  return {
    idAsset,
    Version: BankAccountAssetVersion.Initial,
    idAssetType: IAssetTypeId.BankAccount,
    idAssetCategory: IAssetCategoryId.PersonalProperty,
    data: {
      balance: 0,
      assetLocation: IAssetLocation.Domestic,
      notes: '',
    },
  };
}

export function isBankAccountAsset(asset: IAsset): asset is IBankAccountAsset {
  return asset.idAssetType === IAssetTypeId.BankAccount;
}

export const BankAccountAssetDataSchema = z.object({
  balance: z.number(),
  assetLocation: AssetLocationSchema,
  notes: z.string().optional(),
});

export const BankAccountAssetSchema = GenericAssetSchema(
  z.literal(IAssetTypeId.BankAccount),
  z.literal(IAssetCategoryId.PersonalProperty),
  z.literal(BankAccountAssetVersion.Initial).optional(),
  BankAccountAssetDataSchema
);

export type IBankAccountAsset = z.infer<typeof BankAccountAssetSchema>;
